import { connect } from 'react-redux';

import { impersonateLogin } from './actions';
import ImpersonatePage from './ImpersonatePage';

const actions = {
	onLoad: impersonateLogin,
};

export default connect(undefined, actions)(ImpersonatePage);
